import type { SessionTerminationResponse } from 'src/types/session';
import deleteWithReason from './deleteWithReason';

interface DeleteMySessionsParams {
  tenantId?: string;
  reason?: string;
}

const deleteMySessions = async (
  params?: DeleteMySessionsParams,
): Promise<SessionTerminationResponse> => {
  return deleteWithReason({
    pathType: 'user',
    tenantId: params?.tenantId,
    reason: params?.reason,
  });
};

export default deleteMySessions;
